import { Link } from 'react-router-dom';
import { photoFrame, photos } from '../../../content/media';

export default function CTASection() {
  return (
    <section className="bg-white py-16 lg:py-20">
      <div className="mx-auto px-6 lg:px-10 xl:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div>
            <span className="eyebrow">Ready to Transform?</span>
            <h2 className="text-[28px] lg:text-[40px] font-extrabold text-page-ink tracking-[-0.04em] leading-[1.08] mb-4">
              Let&apos;s build your future-ready IT infrastructure
            </h2>
            <p className="text-page-muted text-sm lg:text-base leading-relaxed mb-8 max-w-xl font-light">
              Schedule a free consultation with our certified experts. We&apos;ll assess your current environment and create a custom roadmap for your digital transformation.
            </p>
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 mb-8">
              <Link to="/contact" className="btn-primary">
                Contact Us Today
                <i className="ri-arrow-right-line text-sm" />
              </Link>
              <Link to="/contact" className="btn-ghost">
                Request a Quote
              </Link>
            </div>
            <div className="flex flex-col sm:flex-row gap-4 sm:gap-8">
              {[
                { icon: 'ri-timer-line', text: 'Free 30-Min Consultation' },
                { icon: 'ri-checkbox-circle-line', text: 'No Commitment Required' },
                { icon: 'ri-shield-check-line', text: 'Satisfaction Guaranteed' },
              ].map(({ icon, text }) => (
                <div key={text} className="flex items-center gap-2 text-page-muted">
                  <i className={`${icon} text-[#c97a2b] text-sm`} />
                  <span className="text-[13px] font-medium whitespace-nowrap">{text}</span>
                </div>
              ))}
            </div>
          </div>
          <div className={`${photoFrame} h-[320px] lg:h-[400px]`}>
            <img src={photos.hero} alt="SunStone team in Lagos" className="w-full h-full object-cover object-center" />
          </div>
        </div>
      </div>
    </section>
  );
}
